import { render } from "./DuelsGames.vue?vue&type=template&id=65502c2b&scoped=true"
import script from "./DuelsGames.vue?vue&type=script&lang=js"
export * from "./DuelsGames.vue?vue&type=script&lang=js"

import "./DuelsGames.vue?vue&type=style&index=0&id=65502c2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65502c2b"]])

export default __exports__